import React from "react";
import PropTypes from "prop-types";
import { Caption } from "@xo-union/tk-ui-typography";
const SubText = _ref => {
  let {
    className,
    id,
    state,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(Caption, {
    id: id,
    className: className,
    "aria-live": state === 'invalid' ? 'polite' : undefined
  }, children);
};
process.env.NODE_ENV !== "production" ? SubText.propTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  state: PropTypes.string,
  children: PropTypes.node
} : void 0;
export default SubText;